module.exports = __webpack_public_path__ + "static/img/1.bf54658.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/sp/1.png
// module id = e+XR
// module chunks = 0